import { render } from "./OverlayNavigation.vue?vue&type=template&id=77d44b34&ts=true"
import script from "./OverlayNavigation.vue?vue&type=script&lang=ts"
export * from "./OverlayNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__